import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { FabBoardComponent } from './fab-board/fab-board.component'
import { FabDeliveriesComponent } from './fab-deliveries/fab-deliveries.component'
import { FabDraftingQueueComponent } from './fab-drafting-queue/fab-drafting-queue.component'
import { FabHoldsComponent } from './fab-holds/fab-holds.component'
import { FabSetupComponent } from './fab-setup/fab-setup.component'
import { FabShopFloorComponent } from './fab-shop-floor/fab-shop-floor.component'
import { FabShopQuickComponent } from './fab-shop-quick/fab-shop-quick.component'

export const fabRoutes: Routes = [
    {
        path: 'fab',
        children: [
            RouteUtil.Make('board', FabBoardComponent, FeatureType.FabBoardView),
            RouteUtil.Make('drafting', FabDraftingQueueComponent, FeatureType.FabDraftingQueueView),
            RouteUtil.Make('shop', FabShopFloorComponent, FeatureType.FabShopFloorView),
            RouteUtil.Make('shop-quick', FabShopQuickComponent, FeatureType.FabShopFloorView),
            RouteUtil.Make('deliveries', FabDeliveriesComponent, FeatureType.FabDeliveryLookaheadView),
            RouteUtil.Make('holds', FabHoldsComponent, FeatureType.FabHoldsView),
            RouteUtil.Make('setup', FabSetupComponent, FeatureType.FabSetupView),
        ],
    },
]
